import { FinancialProposal } from "@/modules/property-tracks/types";
import { Skeleton, Typography } from "@mui/material";
import ProposalItem from "./item";

export default function FinancialProposalList({
  proposals: data,
  isLoading,
  customerUId,
}: {
  proposals: FinancialProposal[] | undefined;
  isLoading: boolean;
  customerUId: string;
}) {
  if (isLoading)
    return Array.from({ length: 3 }).map(() => (
      <Skeleton
        variant="rectangular"
        width="100%"
        height={60}
        sx={(t) => ({ borderRadius: t.nawy.radius.lg })}
      />
    ));

  return data && data?.length > 0 ? (
    data?.map((r) => (
      <ProposalItem key={r.uid} proposal={r} customerUId={customerUId} />
    ))
  ) : (
    <Typography
      variant="caption"
      sx={(t) => ({
        ...t.nawy.typography.english.variants.body.md.regular,
        color: t.nawy.colors.semantic.text.secondary,
      })}
    >
      The property has no financial proposals yet.
    </Typography>
  );
}
